import {useEffect, useState, useMemo, useCallback, useRef} from "react"
import { useNavigate, useLocation } from '@tanstack/react-router'
import Breadcrumb from '../../components/Breadcrumb'
import './CollectionsHeader.css'
import {getMainWidth, handelTitle} from "../../utils"
import SecCollectionList from "../../components/SecCollectionList"
import {chainData} from "../../chains"
import {Modal2} from "../../components/Modal"
import paypalqr from "../../assets/img/paypalqr.png"
import personalwallet from "../../assets/img/personalwallet.png"
import SearchFilterBar from "../../components/SearchFilterBar"

interface Props {
    initialCollections?: any[]
    initialPagination?: any
    initialNetwork?: string
    initialSearch?: string
}

const CollectionsContainer = ({ initialCollections, initialPagination, initialNetwork = 'any', initialSearch }: Props) => {
    const navigate = useNavigate()
    const location = useLocation()
    // Track initialization state to avoid navigation loop on mount
    const isInitialized = useRef(false)
    const prevNetworkRef = useRef<string>(initialNetwork)
    const [searchParam, setSearchParam] = useState(initialSearch ?? '')
    const [network, setNetwork] = useState(initialNetwork)
    const [rerender, setRerender] = useState(0)
    const forceRerender = useCallback(() => setRerender(r => r + 1), [])

    const networkLabel = useMemo(() => {
        const entry = Array.isArray(chainData)
            ? chainData.find((e: any) => e && String(e.chainId) === String(network))
            : null
        return entry ? (entry.chainName || entry.network || '') : ''
    }, [network])

    const handleDisclaimerAccept = () => {
        sessionStorage.setItem('disclaimer', 'accepted')
    }

    useEffect(() => {
        handelTitle('Collections')
        getMainWidth()

        const disclaimerAccepted = sessionStorage.getItem('disclaimer') === 'accepted'
        if (!disclaimerAccepted) {
        }
    }, [])

    // Update URL when network changes (except for 'any' which uses base /collections)
        useEffect(() => {
            if (!isInitialized.current) {
                isInitialized.current = true
                return
            }
            // Network actually changed by user action (not initial load)
            if (network !== prevNetworkRef.current) {
                prevNetworkRef.current = network
            
                if (network !== 'any') {
                    const chainEntry = Array.isArray(chainData)
                        ? chainData.find((e: any) => e && String(e.chainId) === String(network))
                        : null
                
                    if (chainEntry?.chainName) {
                        const slug = chainEntry.chainName.toLowerCase().replace(/\s+/g, '-')
                        navigate({ to: `/collections/${slug}` })
                    }
                } else {
                    navigate({ to: '/collections' })
                }
            }
        }, [network, navigate, chainData])

    return (
        <>
            <main className="main-content" style={{paddingTop: '8px'}}>
                {/* Disclaimer modal */}
                {/* 
                {isDisclaimerVisible && (
                    <Modal2
                        show={isDisclaimerVisible}
                        modalTitle="IMPORTANT"
                        handleClose={handleDisclaimerAccept}
                        content={
                            <div className="text-center">
                                <span>
                                    This site is currently under construction.
                                    <br/><br/>
                                    Some features may not work as expected, or at all.
                                    <br/><br/>
                                    It is provided for the purposes of testing only at this stage.<br/>
                                    <br/>
                                    If you like this project and want me to continue developing it,
                                    please consider donating, I am currently barely able to cover
                                    the server bills and I am receiving zero income at present.<br/>
                                    <br/>
                                    My personal wallet (FLR/SGB/ETH/XDC/XRPL SC) 0x8423f4E4c20185af8A8a7308a534B3be6C75354D<br/>
                                    <img
                                        height={100}
                                        width={100}
                                        //src="https://s3.amazonaws.com/codecademy-content/courses/React/react_photo-goose.jpg"
                                        src={personalwallet}
                                        alt="personal wallet"
                                    />
                                    <br/><br/>
                                    Or via Paypal: 
                                    <form action="https://www.paypal.com/donate" method="post" target="_top">
                                        <input type="hidden" name="hosted_button_id" value="F5CWC68ZPK3AE" />
                                        <input type="image" src="https://www.paypalobjects.com/en_GB/i/btn/btn_donate_SM.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                                        <img alt="" border="0" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1" />
                                    </form>
                                </span>
                            </div>
                        }
                    />
                )}
                */}

                <Breadcrumb text1='Collections' text2={networkLabel || undefined} logo={network !== 'any' ? `/assets/img/chain-logos/chain-${network}.png` : undefined}/>

                <div className="container-fluid collections-container">
                    <div className="col-12 py-0">
                        <div className="pixel-card mt-2">
                            <div className="p-2 pt-42">
                                <SearchFilterBar
                                  searchValue={searchParam}
                                  onSearchChange={setSearchParam}
                                  filterOptions={chainData}
                                  filterValue={network}
                                  onFilterChange={setNetwork}
                                />
                            </div>
                            <SecCollectionList searchParam={searchParam} net={network} rerender={rerender} initialCollections={initialCollections} initialPagination={initialPagination} />
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default CollectionsContainer